import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Data, Router } from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class BrowserHistoryResolver implements Resolve<boolean> {

  constructor(private _router: Router) { }

  /**check if we route to webshop menu from home page or from service select page
   * it is used to define navigate back by browser history or navigate by using router navigate in webshop
   * it will solve the problem to navigate back from the menu to service select or home
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const me = this;
    return new Promise<boolean>((resolve, reject) => {
      if (me._router.url == "/menuservice" || me._router.url == "/menulocation") {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  }
}
